import React from "react";
import { StyleSheet } from "react-native";
import Text from "@components/CustomText";
import BottomSheet from "@components/ds/BottomSheet";
import SheetButtons from "@components/ds/SheetButtons";
import { tokens } from "../styles";

// OUT_OF_AREA confirm sheet — shown from CustomerView. Marks every
// customer on a card with route_id 'MISROUTE'.

const MisrouteSheet = ({ visible, card, onClose, onConfirm, submitting }) => (
  <BottomSheet
    visible={visible}
    title="Mark as Out of Area"
    onClose={onClose}
    footer={
      <SheetButtons
        onCancel={onClose}
        onConfirm={onConfirm}
        loading={submitting}
        destructive
        confirmLabel="Mark Out of Area"
      />
    }
  >
    <Text variant="caption_2" style={styles.body}>
      Mark all customers on{" "}
      <Text variant="caption_2" style={styles.strong}>
        {card?.title || "this card"}
      </Text>{" "}
      as{" "}
      <Text variant="caption_2" style={styles.strong}>
        OUT OF AREA
      </Text>
      ?
    </Text>
  </BottomSheet>
);

export default MisrouteSheet;

const styles = StyleSheet.create({
  body: { color: tokens.textPrimary, fontSize: 13 },
  strong: { color: tokens.textPrimary, fontWeight: "700" },
});
